<template>
	<!-- Vue Material Chips -->
	<!-- https://vuematerial.io/components/chips -->
	<md-chips
		ref="chips"
		:class="{ 'md-invalid': error }"
		:md-auto-insert="true"
		:md-format="formatter"
		:md-placeholder="placeholder"
		:value="value"
		class="shake-on-error"
		@input="$emit('input', $event)"
	>
		<span v-if="hint" class="md-helper-text">{{ hint }}</span>
		<span v-if="error" class="md-error">{{ error }}</span>
	</md-chips>
</template>

<script>
export default {
	name: "Chips",
	props: {
		error: {
			type: String,
			default: "",
			required: false
		},
		formatter: {
			type: Function,
			default: (val) => val,
			required: false
		},
		hint: {
			type: String,
			default: "",
			required: false
		},
		placeholder: {
			type: String,
			default: "Type and press enter to add...",
			required: false
		},
		value: {
			type: Array,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.shake-on-error /deep/ .md-duplicated {
	animation-name: shake;
	animation-duration: 0.5s;
}

@keyframes shake {
	0% { transform: translate(15px); }
	20% { transform: translate(-15px); }
	40% { transform: translate(7px); }
	60% { transform: translate(-7px); }
	80% { transform: translate(3px); }
	100% { transform: translate(0px); }
}

/deep/ .md-chip {
	max-width: 100%; // restrict max chip width to parent container
	overflow: hidden; // needed for IE11
	flex-shrink: 0; // overflow right margin when full chip width
	margin-right: 4px; // compensate margin for alignment fix
	& + .md-chip {
		margin-left: 0; // keep chips aligned when on multiline
	}
	.md-ripple {
		text-overflow: ellipsis; // cut and add ellipsis on overflowing text
	}
}
</style>
